module.exports = ".dx-texteditor {\n    height: 40px;\n}\n\n/deep/ .dx-list {\n    border: 1px solid rgb(223, 215, 215)!important;\n}\n\n.buttons {\n    margin-top: 50%;\n}\n\n.button-profile {\n    margin-right: 10px;\n    margin-left: 10px;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/profile-view/profile-view.component.css
// module id = ./src/app/components/profile-view/profile-view.component.css
// module chunks = main